import { queryKeys } from "../queryKeys";
import { getQuote, type Quote, type StockLatestFeed } from "../rest/data";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetQuote = ({
  symbol,
  feed,
  options,
}: {
  symbol?: string;
  feed?: StockLatestFeed;
  options?: QueryOptions<Quote | null>;
}) => {
  // v5 throws if a query fn resolves `undefined`; store `null` for "no
  // quote found" instead and remap back to `undefined` below.
  const { data, ...rest } = useRequest<Quote | null>(
    queryKeys.quotes.single(symbol || "", feed),
    async () => {
      if (!symbol) {
        throw new Error("symbol required");
      }
      return (await getQuote(symbol, feed)) ?? null;
    },
    {
      ...options,
      enabled: Boolean(symbol) && (options?.enabled ?? true),
    },
  );

  return { quote: data ?? undefined, ...rest };
};

export default useGetQuote;
